import { ThemeProvider, createTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter, useLocation } from "react-router-dom";
import "./App.css";
import Routes from "./routes/index";
import Navbar from "./common/header";
import Footer from "./common/footer";
import { HelmetProvider } from "react-helmet-async";

const getGoogleTranslateLanguage = () => {
  const lang = document.documentElement.getAttribute("lang");
  return ["en", "ja"].includes(lang) ? lang : "ja";
};

// Paths that should NOT show the default Navbar/Footer
const EXCLUDED_LAYOUT_PATHS = ["/lp"];

function AppLayout() {
  const location = useLocation();
  const normalizedPath = location.pathname.replace(/\/$/, "") || "/";
  const hideDefaultLayout = EXCLUDED_LAYOUT_PATHS.includes(normalizedPath);

  return (
    <>
      {!hideDefaultLayout && <Navbar />}
      <Routes />
      {!hideDefaultLayout && <Footer />}
    </>
  );
}

function App() {
  const [language, setLanguage] = useState(getGoogleTranslateLanguage());

  useEffect(() => {
    // Observer to watch for changes on the <html> element
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "lang"
        ) {
          setLanguage(getGoogleTranslateLanguage());
        }
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      subtree: false,
    });

    return () => observer.disconnect();
  }, []);

  const theme = createTheme({
    typography: {
      allVariants: {
        fontFamily: `"Noto Sans JP","sans-serif"`,
        fontSize: 15,
        letterSpacing: language === "ja" ? "2px" : "unset",
      },
    },
  });
  return (
    <>    
      <CookiesProvider key={`lang-${language}`}>
        <ThemeProvider theme={theme}>
          <HelmetProvider>
            <BrowserRouter>
              {/* <Navbar />
              <Routes />
              <Footer /> */}
              <AppLayout />
            </BrowserRouter>
          </HelmetProvider>
        </ThemeProvider>
      </CookiesProvider>
    </>
  );
}

export default App;
